export const global_app_settings = {
  enable_loan_feature: false,
};
